import React from "react";
import { motion } from "framer-motion";
import { ArrowRightIcon, LockIcon } from "lucide-react";
import { goToCheckout, PRICE } from "../src/config";
interface CTAButtonProps {
  label?: string;
  subtext?: string;
  size?: "md" | "lg";
  className?: string;
  showLock?: boolean;
  destination?: "offer" | "checkout";
}
export function CTAButton({
  label,
  subtext,
  size = "lg",
  className = "",
  showLock = true,
  destination = "checkout"
}: CTAButtonProps) {
  const text = label ?? `SÍ, QUIERO MI ACCESO POR ${PRICE}`;
  const handleClick = () => {
    if (destination === "checkout") {
      goToCheckout();
      return;
    }
    document.getElementById("oferta")?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  };
  return <div className={`flex flex-col items-center ${className}`} data-id="element-66" data-mp="3cpu8mvqozglo">
      <motion.button onClick={handleClick} whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.97
    }} className={`animate-pulse-glow group relative w-full max-w-xl rounded-2xl bg-gradient-to-r from-emerald-500 to-emerald-400 font-display font-extrabold uppercase tracking-wide text-emerald-950 shadow-lg shadow-emerald-500/25 transition-colors hover:from-emerald-400 hover:to-emerald-300 ${size === "lg" ? "px-6 py-5 text-lg sm:text-xl" : "px-5 py-4 text-base"}`} data-id="element-67" data-mp="3cq3zeljk9rsf">
        <span className="flex items-center justify-center gap-2 leading-tight" data-id="element-68" data-mp="1n6bd6mz8k60s">
          {showLock && <LockIcon className="h-5 w-5 shrink-0" data-id="element-69" data-mp="1s5o71roiydcv" />}
          <span data-id="element-70" data-mp="1w8aulge5xc49">{text}</span>
          <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform group-hover:translate-x-1" data-id="element-71" data-mp="1w7jab1q0n0ta" />
        </span>
      </motion.button>
      {subtext && <p className="mt-3 text-sm text-slate-400" data-id="element-72" data-mp="25zf9yh7r2yzm">{subtext}</p>}
    </div>;
}